import { Flex, Box, Text, Spinner } from '@chakra-ui/react'

type StatusVariants =
  | 'deploymentInProgress'
  | 'deploymentFailed'
  | 'deploymentDone'
  | string

const Status = ({
  status,
  size = 'md',
  ...props
}: {
  status: StatusVariants
  size?: 'md' | 'lg'
} & Record<string, any>) => {
  const dimension = size === 'lg' ? '12px' : '8px'

  return (
    <Flex alignItems="center" {...props}>
      {status === 'deploymentInProgress' ? (
        <Spinner color="gray.300" size="sm" mr={2} />
      ) : (
        <Box
          rounded="full"
          w={dimension}
          h={dimension}
          mr={2}
          bg={
            status === 'deploymentDone'
              ? 'green.400'
              : status === 'deploymentFailed'
              ? 'red.400'
              : 'gray.300'
          }
        />
      )}
      <Text size={size}>
        {status === 'deploymentInProgress'
          ? 'Deployment in progress'
          : status === 'deploymentDone'
          ? 'Deployed'
          : status === 'deploymentFailed'
          ? 'Deployment failed'
          : 'Unknown status'}
      </Text>
    </Flex>
  )
}

export default Status
